<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="emEquipmentcheck.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="emEquipmentcheck"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="设备编号" prop="equipmentNO">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model="emEquipmentcheck.equipmentNO" placeholder="请输入" readonly>
              <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectEquipmentNO.open()">选择设备</el-button>
            </el-input>
            <equipment-select ref="selectEquipmentNO" @select="selectEquipmentNO"/>
          </div>
        </el-form-item>
        <el-form-item label="点检内容" prop="checkContent">
          <el-input v-model="emEquipmentcheck.checkContent" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="点检方法" prop="checkWay">
          <el-input v-model="emEquipmentcheck.checkWay" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="日点检">
          <el-input v-model="emEquipmentcheck.checkOnDay" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="周点检">
          <el-input v-model="emEquipmentcheck.checkOnWeek" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="月点检">
          <el-input v-model="emEquipmentcheck.checkOnMonth" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  import EquipmentSelect from "@/views/em/Equipment/EquipmentSelect";
  export default {
    name:"EMEquipmentcheckEdit",
    components: {EquipmentSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        emEquipmentcheck: {
          pkid: 0,
          equipmentID: "",
          equipmentNO: "",
          checkContent: "",
          checkWay: "",
          checkOnDay: "",
          checkOnWeek: "",
          checkOnMonth: "",
        },
        ruleValidate: {
          equipmentNO: {required: true, message: "设备编号不能为空",trigger: "blur"},
          checkContent: {required: true, message: "点检内容不能为空",trigger: "blur"},
          checkWay: {required: true, message: "点检方法不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.emEquipmentcheck.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `emEquipmentchecks/${this.emEquipmentcheck.pkid}`)
          .then(resp => {
            console.log(resp);
            this.emEquipmentcheck = resp;
          });
      },
      selectEquipmentNO(row) {
        this.emEquipmentcheck.equipmentID = row.pkid;
        this.emEquipmentcheck.equipmentNO = row.no;
      },
      handleSubmit() {
        if(this.emEquipmentcheck.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "emEquipmentchecks",  this.emEquipmentcheck)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "emEquipmentchecks", this.emEquipmentcheck)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
